module.exports = __webpack_public_path__ + "static/img/202403.998bfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202403.png
// module id = /iVW
// module chunks = 0